import { createFileRoute } from '@tanstack/react-router';

import { getAppProgressOptions } from 'hooks/data/useAppProgress';
import { getisRegistered } from 'hooks/useIsRegistered';

export const Route = createFileRoute('/_auth/_buttonView/_layout/retain/_app/$id')({
  beforeLoad: async ({ context, params }) => {
    const isRegistered = await getisRegistered(context.queryClient, params.id);
    const progressData = await context.queryClient.ensureQueryData(getAppProgressOptions({ resource: params.id }));

    const hiddenButtons = [];

    if (progressData.length > 0) {
      const [{ chapterCompletion }] = progressData;

      if (chapterCompletion !== 100 && isRegistered) {
        hiddenButtons.push('info', 'training');
      }
    }

    if (!isRegistered) {
      hiddenButtons.push('search');
    }

    context.hideButtonBarButtons = [...new Set(hiddenButtons)];

    return context;
  },
});
